import React, {useState, useEffect} from "react"
import SingleTable from "../../components/SingleTable"
import {Spinner} from "../../components/Spinner/index"
import InternalError from "../../components/InternalError"
import TableHeaderSearch from "../../components/TableHeaderSearch/index"
import {UseStores} from "../../hooks/UseStores"
import {observer} from "mobx-react-lite"
import {navigate} from "@reach/router"
import {defaultGeo} from "../../utils/utils"
import config from "../../config"
import Tooltip from "@material-ui/core/Tooltip"
import {makeStyles} from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: "var(--modes-on-primary-container)",
    borderRadius: "4px",
    color: "var(--modes-background)",
    fontFamily: "var(--font-family-regular)",
    fontSize: "var(--font-size-paragraph-large)",
    fontWeight: "var(--font-weight-regular)",
    lineHeight: "var(--line-height)",
    padding: "10px",
    textAlign: "center",
  },
  arrow: {
    color: "var(--modes-on-primary-container)",
  },
}))

const LGHome = () => {
  const {paginationStore, locGroupStore, navStore} = UseStores()

  const classes = useStyles()

  const {tagId, tenantId, companyId, accountId} = locGroupStore

  useEffect(() => {
    setFilterObj({accountName: ""})
  }, [locGroupStore.locGeoTime])

  const handleGroupNameClick = (rowData) => {
    const {name, id} = rowData
    const {geoType, geoId} = defaultGeo
    handleRowClick(rowData)
    locGroupStore.setTagId(rowData.id)
    locGroupStore.setGeoNonePOI(locGroupStore.locGeoTime.geo)
    navigate(
      `/locationgroups/locations?name=${name}&tagId=${id}&geoType=${geoType}&geoId=${geoId}`
    )
    navStore.setLocationGroupName(name)
  }
  const [filterObj, setFilterObj] = useState({accountName: ""})

  const handleSearch = ({k, v}) => {
    paginationStore.currentPage = 1
    setFilterObj({...filterObj, [k]: v})
  }

  //account name filtering
  const filterData = (data) => {
    //  for account search in table
    let filtered = data.filter((item) => {
      const accountName = item["accountName"] === null ? "" : item["accountName"]
      return accountName
        .replace(/\s*,\s*/g, ",")
        .toLowerCase()
        .trim()
        .includes(
          filterObj["accountName"]
            .replace(/\s*,\s*/g, ",")
            .toLowerCase()
            .trim()
        )
    })
    return filtered
  }

  const handleRowClick = (rowData) => {
    locGroupStore.setTableStates({selected: rowData.id})
    locGroupStore.setGeoServiceObj({selected: rowData.id})
    locGroupStore.setAccountId(rowData.accountId)
  }

  const handleEditIconClick = (rowData) => {
    handleRowClick(rowData)
    locGroupStore.setTagId(rowData.id)
    locGroupStore.setCompanyId(rowData.companyId)
  }

  const pinIconText = `Locations`

  const columns = [
    {
      name: "",
      key: "Edit",
      sortable: false,
      width: "2",
      type: "custom",
      content: (
        <a
          href={`${config.api.LM_Deep_Linking_URL}/location_groups/${tagId}/accepted?tenant_id=${tenantId}&account_id=${accountId}&account_country_id=0&account_country=US&company_id=${companyId}`}
          target="_blank"
          rel="noopener noreferrer"
          className="edit-link"
        >
          <div className="edit-icon"></div>
        </a>
      ),
      onCellClick: handleEditIconClick,
    },
    {
      name: "Group Name",
      key: "name",
      sortable: true,
      width: "23",
      class: "group-name",
      headClass: "lg-groupname",
      onCellClick: handleRowClick,
    },
    {
      name: " ",
      // key: 'name',
      sortable: false,
      width: "5",
      type: "custom",
      class: "lg-pinicon",
      headClass: "lg-pinicon",
      content: (
        <div className="pin-icon-container">
          <Tooltip
            title={pinIconText}
            arrow
            placement="bottom-start"
            classes={{arrow: classes.arrow, tooltip: classes.tooltip}}
          >
            <div className="pin-icon"></div>
          </Tooltip>
        </div>
      ),
      onCellClick: handleGroupNameClick,
    },
    {
      name: (
        <TableHeaderSearch
          name="accountName"
          handleSearch={handleSearch}
          placeholder="Account"
          type="lgroup"
        />
      ),
      key: "accountName",
      sortable: true,
      width: "25",
      onCellClick: handleRowClick,
    },
    {
      name: "Locations",
      key: "locations",
      sortable: true,
      width: "18",
      headClass: "lg-locations",
      onCellClick: handleRowClick,
    },
    {
      name: "Visits",
      key: "visits",
      sortable: true,
      width: "13",
      headClass: "lg-visits",
      onCellClick: handleRowClick,
    },
  ]

  const {tableDataLoading, tableData, tableDataError, selected} =
    locGroupStore.tableStates

  let filteredData

  if (tableData && tableData.length > 0) {
    filteredData = filterData(tableData)
  }

  if (tableDataLoading) return <Spinner />
  if (tableDataError) return <InternalError />

  return (
    <div data-testid="lg" className="location-container">
      {filteredData && (
        <SingleTable
          columns={columns}
          data={filteredData}
          pagination={true}
          selectableRows={true}
          selectedRow={selected}
          searchKey={filterObj.accountName}
        />
      )}
    </div>
  )
}
export default observer(LGHome)
